module.exports = __webpack_public_path__ + "static/rego-93dc5aa3f20e1f1950843ffe0da13c3b.png";